import withDisplayName from 'bz-utilities/hoc/display-name';
import useComputed from 'bz-utilities/hooks/computed';
import useConst from 'bz-utilities/hooks/const';
import { observer, Provider } from 'mobx-react';
import type React from 'react';
import { cache } from 'tm3-core/cache';
import Feature from 'tm3-core/controls/feature';
import PayFeatures from 'tm3-pay/features';
import TerminalPaymentDialog from './index';
import TerminalPaymentDialogStore, {
  TerminalPaymentDialogStoreCtx
} from './stores/terminal-payment-dialog-store';

interface IProps extends React.PropsWithChildren {}

const TerminalDialogWrapper = observer(
  withDisplayName((props: IProps) => {
    const store = useConst(() => new TerminalPaymentDialogStore());

    const { children } = props;

    const clearAcceptTerminalFeature = useComputed(
      () =>
        cache.isClick ? PayFeatures.ClickClearAcceptTerminal : PayFeatures.ClearAcceptTerminal,
      []
    );

    return (
      <Provider terminalPaymentDialogStore={store}>
        <TerminalPaymentDialogStoreCtx.Provider value={store}>
          <>
            <Feature
              valueOr={[
                PayFeatures.SquareTerminal,
                clearAcceptTerminalFeature,
                PayFeatures.StripeTerminal
              ]}
              fallback={null}
            >
              <TerminalPaymentDialog />
            </Feature>
            {children}
          </>
        </TerminalPaymentDialogStoreCtx.Provider>
      </Provider>
    );
  }, 'TerminalDialogWrapper')
);
export default TerminalDialogWrapper;
